export default __webpack_public_path__ + "static/media/SFTSchriftedSansTRIAL-ExtraLight-BF6413e1ed0f558.69b8234c.otf";